var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCalendar = function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    "data-name": "Component 12 \\u2013 1",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4cc0ad",
    d: "M17 2h-2V1a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1H8V1a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v1H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-5 0h1v2h-1ZM5 2h1v2H5ZM2 16V7h14v9Z",
    "data-name": "Path 70"
  })));
};
export default SvgIconCalendar;